<div *ngFor="let c of cahiers">
    <h6 *ngIf="c.grand_titre == 1"> {{c.reference}} - {{c.activite}} </h6>
    <p *ngIf="c.grand_titre == 0">{{c.reference}} - {{c.activite}} </p>
</div>